import { NgModule } from '@angular/core';
import { InboxComponent } from './clmtlk/inbox/inbox.component';
import { PreloadAllModules, Routes, RouterModule } from '@angular/router';
import {ThreadComponent } from './clmtlk/thread/thread.component';
import { InboxResolver } from 'app/clmtlk/inbox/shared/inbox-resolver.service';
import { NewMessageComponent } from 'app/clmtlk/new-message/new-message.component';
import { NewMessageResolver } from 'app/clmtlk/new-message/shared/new-message-resolver.service';
import { UnauthorizeComponent } from 'app/common/component/401-unauthorize.component';
import { ClmtlkCanDeactivate } from 'app/clmtlk/shared/service/clmtlk-candeactivate.service';
import { LoginComponent } from 'app/clmtlk/login/login.component';
import { AutoCompleteResolver } from 'app/clmtlk/new-message/shared/autocomplete-resolver.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/inbox',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'inbox',
    component: InboxComponent,
    resolve: {
      convContacts: InboxResolver
    }
  },
  {
    path: 'convo/:conv_id/:thread/:thrd_id',
    component: ThreadComponent
  },
  {
    path: 'message/:action',
    component: NewMessageComponent,
    resolve: {
      conversation: NewMessageResolver,
      streamContacts: AutoCompleteResolver
    },
    canDeactivate: [ClmtlkCanDeactivate]
  },
  {
    path: '401',
    component: UnauthorizeComponent
  },
   {
    path: '**',
    redirectTo: '/inbox'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/app-routing.module.ts